import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  membership_comission_value: yup
    .number()
    .required('Preencha um valor maior que 1%.')
    .min(1, 'Preencha um valor maior que 1%.')
    .max(99, 'Preencha um valor menor que 99%'),
  recurring_comission_value: yup
    .number()
    .required('Preencha um valor maior que 1%.')
    .min(1, 'Preencha um valor maior que 1%.')
    .max(99, 'Preencha um valor menor que 99%'),
});
